import { IObservableController } from "elements/base/observable";
import { useEffect, useState } from "react";

export default function useObservableController<T extends IObservableController>(
  controller?: T | null,
  events?: string | string[],
  updateFunction?: () => void
) {
  const [renderCount, setRenderCount] = useState(0);

  useEffect(() => {
    if (!controller) return;
    const handleUpdate = () => setRenderCount((previous) => previous + 1);
    controller.subscribe(handleUpdate, events);
    return () => controller.unsubscribe(handleUpdate);
  }, [controller, events]);

  useEffect(() => {
    if (updateFunction) {
      updateFunction();
    }
    // The update function is not in the deps array due to it not always being a memoed callback.
    // This allows us to pass arrow functions such as () => { console.log("update"); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderCount]);
}
